import Common from '../common/CommonPowerbook';

class TmplObjectMonster {

    constructor() {
        this.comm = Common.instance;
    }

    make(_d){
         return `
<section class="object object-monster">
    <header class="object__header">
        <img class="object__icon" src="${this.comm.staticImgURL}/powerbook/lineage/${_d.image}" alt="">
        <span class="object__name"><a href="${this.comm.powerbookURL}/${_d.name}">${_d.name}</a></span>
    </header>
    <article class="object__attribute">
        <table>
            <tbody>
                <tr>
                    <th scope="col">레벨</th>
                    <td>${_d.level||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">방어력</th>
                    <td>${_d.armor_class||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">HP</th>
                    <td>${_d.hp||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">MP</th>
                    <td>${_d.mp||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">성향치</th>
                    <td>-</td>
                </tr>
                <tr>
                    <th scope="col">마법방어력</th>
                    <td>${_d.magic_resist||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">취약 속성</th>
                    <td>${_d.weak_attribute||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">특성</th>
                    <td>${_d.feature||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">크기</th>
                    <td>${_d.size||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">출현지역</th>
                    <td>${this.locationList(_d.location)}</td>
                </tr>
                <tr>
                    <th scope="col">드롭아이템</th>
                    <td>${this.getdropItemList(_d.drop_item_list)}</td>
                </tr>
                
            </tbody>
        </table>
    </article>
</section>`
    }

    locationList (_d){
        if(!_d) return '';
        let list = _d.split(/,|\s,/);
        return list.map( item => `<a href="${this.comm.powerbookURL}/${item}">${item}</a>` ).join(', ');
    }

    getdropItemList(_d){
        return `
<div class="drop-item">
	${this.dropItemList(_d.filter( item => (!!item && item.object_name == "무기") ), "무기")}
	${this.dropItemList(_d.filter( item => (!!item && item.object_name == "방어구") ), "방어구")}
	${this.dropItemList(_d.filter( item => (!!item && item.object_name == "액세서리") ), "액세서리")}
	${this.dropItemList(_d.filter( item => (!!item && item.object_name == "일반 아이템") ), "일반 아이템")}
	${this.dropItemList(_d.filter( item => (!!item && item.object_name == "마법용품") ), "마법용품")}
</div>`;
    }

    dropItemList(_list, _title){
        if(!_list.length) return '';
        return `
<div class="drop-item__bundle">
    <strong class="drop-item__bundle-tit">${_title}</strong>
    <ul class="drop-item__list">${this.dropItem(_list)}</ul>
</div>`;
    }

    dropItem(_d){
        return _d.map( item => `<li><a href="${this.comm.powerbookURL}/${item.name}" class="drop-item__link">${item.name}</a></li>` ).join('');
    }

}

export default TmplObjectMonster;




// WEBPACK FOOTER //
// ./lineage/TmplObjectMonster.js